import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=1c30b038&scoped=true&"
import script from "./marquee.vue?vue&type=script&lang=js&"
export * from "./marquee.vue?vue&type=script&lang=js&"
import style0 from "./marquee.vue?vue&type=style&index=0&id=1c30b038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30b038",
  null
  
)

component.options.__file = "marquee.vue"
export default component.exports